import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=04759e04&"
import script from "./aside.vue?vue&type=script&lang=ts&"
export * from "./aside.vue?vue&type=script&lang=ts&"
import style0 from "./aside.vue?vue&type=style&index=0&id=04759e04&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports